// TODO: upgrade to RHF
import combineErrorList from "./combineErrorList.js";
import { FIELD_VALIDATION_RULES } from "../consts/validationRule";

/**
 * В функцию передается перечень с настройками для проверки.
 * В случае ошибки валидации необходимо отобразить соответствующий текст
 * и подсветить поля с ошибками
 *
 * @param {Array<Object>} options
 */
export function validateFields(options) {
  options
    .sort((prev, next) => prev.order - next.order)
    .forEach(option => {
      // Проверка поля на пустое значение
      if (FIELD_VALIDATION_RULES.EMPTY_LENGTH === option.type) {
        if (!option.targets[0]?.length) {
          showErrorText(option);
        } else {
          hideErrorText(option);
        }
      }

      // Проверка нахождения значения в диапазоне
      if (FIELD_VALIDATION_RULES.COMPARE_RANGE_SUM === option.type) {
        if (!option.condition) {
          showErrorText(option);
        } else {
          hideErrorText(option);
        }
      }

      // Сравнение искомых значений
      if (FIELD_VALIDATION_RULES.COMPARE_VALUES === option.type) {
        if (!option.condition) {
          showErrorText(option);
        } else {
          hideErrorText(option);
        }
      }

      // Сравнение количества символов
      if (
        FIELD_VALIDATION_RULES.COMPARE_LENGTHS === option.type &&
        option.targets[0] &&
        option.targets[1]
      ) {
        if (option.targets[0] !== option.targets[1]) {
          showErrorText(option);
        } else {
          hideErrorText(option);
        }
      }

      // Проверка на минимально допустимую длину поля
      if (FIELD_VALIDATION_RULES.COMPARE_MIN_LENGTH === option.type) {
        const condition =
          option.condition !== undefined ? option.condition : option.targets[0]?.length < 4;
        if (condition) {
          showErrorText(option);
        } else {
          hideErrorText(option);
        }
      }

      // Проверка количества введенных символов для поля с номером телефона
      if (FIELD_VALIDATION_RULES.PHONE_NUMBER_NOT_FULLY === option.type) {
        if (option.targets[0].replace(/\D+/g, "").length < 11) {
          showErrorText(option);
        } else {
          hideErrorText(option);
        }
      }
    });
}

/**
 * Отобразить ошибку валидации
 *
 * @param {Object} option
 */
function showErrorText(option) {
  option.setter(prevState => combineErrorList(prevState, option.error, [...option.refs], true));
}

/**
 * Скрыть ошибку валидации
 *
 * @param {Object} option
 */
function hideErrorText(option) {
  option.setter(prevState => combineErrorList(prevState, option.error, [...option.refs], false));
}

/**
 * Установить значение для поля ввода
 *
 * @param {String|Object} value
 * @param {Function} setter
 * @param {?Array<Object>} options
 */
export function changeInput(value, setter, options) {
  setter(value);
  validateFields(options);
}
